import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { enGB } from 'date-fns/locale'


const DateRangeSelector = (props) => {
    const { fromDate, toDate, onFromDateChange, onToDateChange, small, hideTitle } = props;
    const { t } = useTranslation();
    return (
        <Stack direction="row" spacing={2}>
            { !hideTitle &&
            <Typography component="h2" variant="h6" color="primary">
                {t("Date")}
            </Typography>
            }
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                <DatePicker
                    label={t("datePickerFrom")}
                    value={fromDate}
                    onChange={(newValue) => {
                        onFromDateChange(newValue);
                    }}
                    renderInput={(params) => small? <TextField fullWidth size="small" {...params} /> : <TextField {...params} />}
                />
                <DatePicker
                    label={t("datePickerTo")}
                    value={toDate}
                    onChange={(newValue) => {
                        onToDateChange(newValue);
                    }}
                    renderInput={(params) => small? <TextField fullWidth size="small" {...params} /> : <TextField {...params} />}
                />
            </LocalizationProvider>
        </Stack>

    )
}

export default DateRangeSelector